export const KEY_SESSION = 'ImpersonationID';
export const KEY_SESSION_ASPDOTNET = 'ImpersonatorFESO';
export const ERROR_MESSAGE_IMPERSONATOR =
	'An error has occurred while trying to identify the impersonation user.';
export const ERROR_MESSAGE_IMPERSONATOR_UNKNOWN =
	'Impersonation user could not be identified.';
